import React from 'react'
import { utilService } from 'core/services'
import ClassNames from 'classnames'
import styled from 'styled-components'
import * as interfaces from 'static/interfaces'
import * as constants from 'static/constants'
import { ISelectedGuests, shouldShowStartTimeLeft } from 'utils/reservation'

interface IStartTimesProps {
  available: boolean
  startTime: interfaces.IStartTime
  guests: ISelectedGuests
  selectedStartTime: interfaces.IStartTime | null
  setSelectedStartTime: (startTime: interfaces.IStartTime) => void
}

export const StartTimeSelectButton = React.memo(
  ({ available, startTime, guests, selectedStartTime, setSelectedStartTime }: IStartTimesProps) => {
    const guestCount = guests.adults + guests.children

    return (
      <StartTimeButton
        type="button"
        className={ClassNames({
          selected: selectedStartTime?.start_time === startTime.start_time,
          closed: !available,
        })}
        disabled={!available}
        onClick={() => setSelectedStartTime(startTime)}
      >
        {utilService.formatWithAmPm(startTime.start_time)}
        {shouldShowStartTimeLeft(startTime, guestCount) && (
          <span className="Guest_Left_Count">
            <strong>{startTime.available_count} </strong>Left
          </span>
        )}
      </StartTimeButton>
    )
  }
)

const StartTimeButton = styled.button`
  position: relative;
  min-width: 84px;
  padding: 8px;
  border: 1px solid ${constants.COLORS.primary};
  border-radius: 0.4rem;
  background: ${constants.COLORS.white};
  color: ${constants.COLORS.primary};
  font-size: 1.6rem;
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    font-size: 1.4rem;
  }
  &.selected {
    background: ${constants.COLORS.primary};
    color: ${constants.COLORS.white};
    font-weight: bold;
  }
  &.closed {
    background: ${constants.COLORS.lightGray};
    border-color: ${constants.COLORS.divider};
    color: ${constants.COLORS.divider};
    cursor: not-allowed;
  }
  .Guest_Left_Count {
    font-weight: normal;
    position: absolute;
    top: -1.2rem;
    right: 0.2rem;
    padding: 0.2rem 0.4rem;
    border: 1px solid ${constants.COLORS.primary};
    border-radius: 0.4rem;
    background: ${constants.COLORS.white};
    color: ${constants.COLORS.primary};
    font-size: 1rem;
  }
`
